// contexts/DoctorContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const DoctorContext = createContext();

export const useDoctor = () => {
  const context = useContext(DoctorContext);
  if (!context) {
    throw new Error('useDoctor must be used within a DoctorProvider');
  }
  return context;
};

export const DoctorProvider = ({ children }) => {
  const [doctorName, setDoctorName] = useState('');
  const [isInitialized, setIsInitialized] = useState(false);

  // Load doctor name from localStorage on mount
  useEffect(() => {
    const savedDoctorName = localStorage.getItem('doctorName');
    if (savedDoctorName) {
      setDoctorName(savedDoctorName);
    }
    setIsInitialized(true);
  }, []);

  // Save doctor name to localStorage whenever it changes
  useEffect(() => {
    if (doctorName) {
      localStorage.setItem('doctorName', doctorName);
    }
  }, [doctorName]);

  const updateDoctorName = (newName) => {
    setDoctorName(newName);
  };

  const clearDoctorName = () => {
    setDoctorName('');
    localStorage.removeItem('doctorName');
  };

  const value = {
    doctorName,
    isInitialized,
    updateDoctorName,
    clearDoctorName
  };

  return (
    <DoctorContext.Provider value={value}>
      {children}
    </DoctorContext.Provider>
  );
};
